import { apiClient } from "../config";
async function createNewPassword(data: any) {
  const res = await apiClient.post(`/admin/new-password`, data);
  return res.data;
}

export default createNewPassword;
